import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/AddCompany';
import { useAuthValidation } from '../../utils/hooks';

const AddCompanyPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default AddCompanyPage;
